
import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import util from '@/lib/util'

@Component({})
export default class Error extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'no-permission'

  doBack() {
    this.$store.commit('app/setActiveMenuName', '')
    this.$store.commit('app/logout', this)
    util.abp.auth.clearToken()
    location.reload()
  }
}
